export default __webpack_public_path__ + "static/media/completedJob.e6882817.svg";